import { render, staticRenderFns } from "./FitnessExercises.vue?vue&type=template&id=3ae50a37&scoped=true&"
import script from "./FitnessExercises.vue?vue&type=script&lang=js&"
export * from "./FitnessExercises.vue?vue&type=script&lang=js&"
import style0 from "./FitnessExercises.vue?vue&type=style&index=0&id=3ae50a37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae50a37",
  null
  
)

export default component.exports